import {toast} from "react-toastify";

export const pushToast = (text, type) => {
  toast(text, {type})
}
